/* Template: Resources
 ========================================================================== */

template.resources = debounce( function() {

    const resource_sidebar = $('.resource_sidebar'),
        resource_form = $('.resource_checkout-form .gform_body');

    let mq = template.media_query();

    if( resource_form.length > 0 ) {

        if (['md', 'lg', 'xl'].indexOf(mq) !== -1) {
            if (resource_sidebar.length > 0) {
                let resource_form_top = resource_form.offset().top;
                resource_sidebar.offset({top: resource_form_top});
            }
        } else {
            resource_sidebar.css('top', '0');
        }

    }

} );

window.addEventListener('resize', template.resources);